const config = {
    API_URL: 'https://customerengagement.aeonsolutionscenter.com/api',
    // API_URL: 'http://localhost:8000/api',
    TOKEN_KEY: 'MYAEON:E_STAMP_TOKEN',
};

export default config;
